module.exports = __webpack_public_path__ + "static/img/001.454df81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/factory/001.jpg
// module id = WsUL
// module chunks = 1